import { Facebook, Instagram, YouTube } from '@mui/icons-material';
import { Link, List, ListItem, Typography } from '@mui/material';
import { Box } from '@mui/system';

import { useClientContext } from 'context/ClientContext';

const socialIcons = {
    youtube: <YouTube sx={{ mr: 1 }} />,
    facebook: <Facebook sx={{ mr: 1 }} />,
    instagram: <Instagram sx={{ mr: 1 }} />,
} as const;

export function FooterList() {
    const { footer = [] } = useClientContext();

    return (
        <Box sx={{ display: 'flex', width: '100%' }}>
            {footer.map(({ dsTitle, links }) => (
                <List dense disablePadding key={`footer_block_${dsTitle}`} sx={{ flex: 1, display: 'block', maxWidth: 240, textAlign: 'left' }}>
                    <Typography sx={{ px: 2, color: 'common.white' }} variant="h6" component="li">
                        {dsTitle.toUpperCase()}
                    </Typography>

                    {links.map(({ dsTitle, dsLink, dsIcon }) => (
                        <ListItem key={`footer_link_${dsTitle}`} sx={{ justifyContent: { xs: 'center', md: 'flex-start' } }}>
                            <Link href={dsLink} target="_blank" color="inherit" sx={{ display: 'flex' }}>
                                {dsIcon ? socialIcons[dsIcon as keyof typeof socialIcons] : null} {dsTitle}
                            </Link>
                        </ListItem>
                    ))}
                </List>
            ))}
        </Box>
    );
}
